import React from "react";
import DiscoverItem from "../common/DiscoverItem";
import SectionTitle from "../common/SectionTitle";
import useAuth from "../../Hooks/useAuth";

const Discover = () => {
  const {data} = useAuth();

  return (
    <section className="discover">
      <div className="container">
        <div className="discover-wrapper">
          <SectionTitle
            title="Discover NF"
            span="Ts"
            titleBtn="See All"
            linkPath="popular"
            color="color-black"
          />
          <div className="discover-items">
            {data.slice(0, 8).map((ele) => {
              return <DiscoverItem data={ele} key={ele.id} />;
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Discover;
